import React from 'react';
import Link from 'next/link';

import StatusBadge from '@core/components/dashboardcoursecard/statusbadge/StatusBadge';
import { Box, LinearProgress } from '@mui/material';
import ProficiencyBadge from '@core/components/proficiencybadge/ProficiencyBadge';

import PremiumBadge from 'assets/icons/premium-badge.svg';
import CompletedIcon from 'assets/icons/completed-icon.svg';
import InProgressIcon from 'assets/icons/inprogress-icon.svg';
import NotStartedIcon from 'assets/icons/notstarted-icon.svg';

import classes from './CareerCourseCard.module.scss';


const CareerCourseCard = ({ data }) => {

    return (
        <div className={classes['wrapper']}>
            <div className={classes['icon-wrapper']}>
                {data.status === 'completed' ? (
                    <CompletedIcon />
                ) : data.status === 'ready' ? (
                    <NotStartedIcon />
                ) : (
                    <InProgressIcon />
                )}
            </div>
            <Link href={`/courses/${data.id}/${data.slug}`} className='w-100'>
                <div className={classes['card-wrapper']}>
                    <img src={data.image} alt={data.title} />
                    <div className={classes['content']}>
                        <div>
                            {data?.is_free ?
                                (
                                    <div className={classes['free-badge']}></div>
                                ) : (
                                    <div className='mb-1'>
                                        <PremiumBadge />
                                    </div>
                                )
                            }
                            <h3>{data.title}</h3>
                            <p>{data.short_introduction}</p>
                        </div>
                        <div className={`d-flex justify-content-between align-items-md-center align-items-start  flex-md-row flex-column ${classes['status-wrapper']}`}>
                            <div className={classes['progress-wrapper']}>

                                {(data.status == 'quiz' || data.status == 'completed') && (
                                    <StatusBadge status={data.status} />
                                )}
                                {data.progress_percentage && data.status === 'progressing' && (
                                    <Box className='mb-3 w-75'>
                                        <span className={classes['percentage']}>{data.progress_percentage}% Completed</span>
                                        <LinearProgress
                                            variant="determinate"
                                            value={data.progress_percentage}
                                            sx={{
                                                borderRadius: '5px', // Adjust border radius
                                            }}
                                        />
                                    </Box>
                                )}
                            </div>
                            <div>
                                <ProficiencyBadge proficiency={data.proficiency} />
                            </div>
                        </div>
                    </div>

                </div >
            </Link>
        </div>
    );
};

export default CareerCourseCard;